import { GastoDetalle } from "./gasto-detalle";
import { Proveedor } from "./proveedor";
import { Bodega } from "./bodega";
import { Cliente } from "./cliente";
import { Pago } from "./pago";
import { Retencion } from './retencion';
import { Guiaremision } from "./guiaremision";
import { Amortizacion } from "./amortizacion";

export class Gasto {
    public constructor(
        public id: String = "",
        public numero_documento: String = "",
        public descripcion: String = "",
        public serie: String = "",
        public punto_emision: String = "",
        public secuencial: String = "",
        public fecha_caducidad: String = "",
        public fecha_emision: String = "",
        public numero_autorizacion: String = "",
        public tipo_actividad: String = "G",
        public tipo: String ="CO",
        //
        public subtotal_iva12:number = 0,
        public subtotal_iva0:number = 0,
        public desct_valor:number = 0,
        public subtotal:number = 0,
        //
        public iva:number = 0,
        public abonado:number = 0,
        public total: number = 0,
        //public tipo_documento_id: String = "",

        public asignacion_caja_id:String = null,

        public empresa_id: String = "",
        public sucursal_id: String = "",
        public proveedor_id: String = "",
        public bodega_id: String = "1",
        public usuario_id:String = null,
        public detalle: Array<GastoDetalle> = [],
        public cliente: Cliente = new Cliente(),

        //
        public proveedor: Proveedor = new Proveedor(),
        public bodega: Bodega = new Bodega(),
        public pagos: Array<Pago> = [],
        public retencion: Retencion = new Retencion(),
        public guiaremision: Guiaremision = new Guiaremision(),
        public amortizacion: Amortizacion = new Amortizacion()
    ){
        
    }
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/gasto.ts